<script lang="ts">
    import {navSlider} from "./NavSlider";
    import {FTNAV_EVENT} from "../../../events/ftnavEvents";
    import {searchfieldStore} from "../../../store/SearchfieldStore";
    import {sendTrackingLabelOnFocus} from "../../../store/TrackingStore";
    import {tracking} from "../../../tracking/Tracking";
    import {SQRL_EVENT} from "../../../events/sqrlEvents";
    import {onSearchFocus} from "../../../index";

    let {value} = searchfieldStore;

    /**
 *
 *
 *
 *
 */
    function renderNavSlider(node: Node) {
        node.appendChild(navSlider.template);
        if ($sendTrackingLabelOnFocus) {
            /*                                                                          */
            window.o_global.events().once(FTNAV_EVENT.REGISTERED_SLIDER, (id: string) => {
                if (id === "squirrel_nav_slider_wrapper") {
                    navSlider.updateHTMLTemplateOnce();
                    tracking.trackCreateEventContext(SQRL_EVENT.SEARCH_FOCUS, onSearchFocus);
                }
            });
            window.o_global.events().emit(FTNAV_EVENT.REGISTER_SLIDER, "squirrel_nav_slider_wrapper");
        } else {
            /*                                                         */
            let eventMetaData = {}
            /*                                                                                                         */
            if ($value) {
                eventMetaData = {empty_suggest_notrack: true};
            }
            window.o_global.events().emit(FTNAV_EVENT.REGISTER_SLIDER, "squirrel_nav_slider_wrapper", eventMetaData);
        }
    }


</script>

<div use:renderNavSlider></div>
